import script from "./CategoriesSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesSelection.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesSelection.vue?vue&type=style&index=0&id=3fbae35c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbae35c"]])

export default __exports__